// firestore
import { Env } from "@zickko/shared";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { clientConfig } from "../config/clientConfig";
import { firebaseApp } from "./firebaseApp";

export const firebaseFunctions = getFunctions(firebaseApp);

// emulator for local
if (clientConfig.env == Env.local) {
  console.log(`Connecting to local firestore emulator`);
  connectFunctionsEmulator(firebaseFunctions, "127.0.0.1", 5001);
}
